import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import React from "react";

import { LocationList } from "@/modules/locations/components";

type Props = {};

export function LocationsListPage(props: Props) {
  const {} = props;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>

          <IonTitle>רשימת כל המקלטים</IonTitle>

          <IonButtons slot="end" />
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <LocationList />
      </IonContent>
    </IonPage>
  );
}
